module.exports = __webpack_public_path__ + "static/media/icon-new-progress-incorrect.869b6905.svg";